import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { User } from '../shared/models/User';
import { GlobalService } from '../shared/services/global';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild(LoginComponent, { static: false }) LoginComp: LoginComponent;
  HideLogin: boolean;
  CurUser: User;
  constructor(private global:GlobalService,private router:Router) {

  }

  ngOnInit() {
    debugger;
    this.HideLogin = true;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      if (this.CurUser) {
        this.router.navigate(['/dashboard']);
      }
      else {
        this.router.navigate(['/']);
      }
      this.HideLogin = false;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => { this.LoginComp.ActionEventEmitter.subscribe(user => this.ProcessLogin(user)); }, 1000);
    //this.LoginComp.ActionEventEmitter.subscribe(user => this.ProcessLogin(user));
  }

  ProcessLogin(userObj: User) {
    if (userObj) {
      //successful login, go to project library
      this.router.navigate(['/dashboard']);
    }
    else {
      //login unsuccesful

    }

  }
}
